import React from 'react';
import PartnersImage from '../assets/partners.png';

const Footer = () => (

  <footer className="footer__main">
    <div className="footer__wrapper-top">
      <div className="footer__content footer__content__image">
        <img src={ PartnersImage } width="520" alt="Partners Logo" />
      </div>
      <div className="footer__content footer__content__db">
        ©
        { ' ' }
        { new Date().getFullYear() }
        , Digital Barometer
        { ' ' }
      </div>

    </div>
    <div className="footer__wrapper-bottom">
      <div className="footer__content">
        Proudly Built By
        { ' ' }
        <a href="https://marzeelabs.org/" rel="noopener noreferrer" target="_blank">Marzee Labs</a>
      </div>
    </div>
  </footer>
);
export default Footer;
